import React from "react";
import ModalVideo from "react-modal-video";
import { Link } from "gatsby-plugin-react-i18next";
import Loadable from "@loadable/component";
import { useTranslation } from "gatsby-plugin-react-i18next";
import seoAnalysis from "../../assets/images/seo-analysis.png";
import ReactWOW from "react-wow";
import partner3 from "../../assets/images/partner/partner3.png";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
	loop: true,
	nav: true,
	dots: false,
	autoplayHoverPause: true,
	autoplay: true,
	items: 1,
	navText: [
		"<i class='flaticon-left'></i>",
		"<i class='flaticon-right'></i>",
	],
};

const CPa = () => {
	const { t } = useTranslation();

	// Popup Video
	const [isOpen, setIsOpen] = React.useState(true);
	const openModal = () => {
		setIsOpen(!isOpen);
	};

	// Owl Carousel
	const [display, setDisplay] = React.useState(false);

	React.useEffect(() => {
		setDisplay(true);
	}, []);

	return (
		<React.Fragment>
			{/* If you want to change the video need to update videoID */}
			{display && (
				<ModalVideo
					channel="youtube"
					isOpen={!isOpen}
					videoId="tuf8Ovjbzec"
					onClose={() => setIsOpen(!isOpen)}
				/>
			)}


			<div className="main-banner-item item-bg1">
				<div className="d-table">
					<div className="d-table-cell">


						<div className="container">
									<div className="banner-item-content">
										<span className="sub-title">
										</span>
										<h1>{t("home.CPah01")}</h1>
										<p>{t("home.CPap01")}</p>
										<div className="container">
											<div className="row-cols-1">
													<div className="analysis-form">
														<span className="sub-title">{t('home.Di01')}</span>
													</div>

												<div className="row-cols-2">
														<Link
														to="https://admin.crowlr.com/register"
														className="default-btn"
													>
														<i className="flaticon-right"></i>
														{t("Créeruncomptegratuit")}
														<span></span>
														</Link>
												</div>

												<div className="btn-box">
												<Link
															to="/about-us"
															className="default-btn"
														>
															<i className="flaticon-right"></i>
															About Us <span></span>
														</Link>

												<Link
															to="#play-video"
															onClick={(e) => {
																e.preventDefault();
																openModal();
															}}
															className="video-btn popup-youtube"
														>
															<i className="flaticon-google-play"></i>{" "}
															Watch Video
														</Link>
												</div>

											</div>

											</div>
										</div>

									</div>
								</div>
							</div>
						</div>

					<div className="main-banner-item single-scientist-item">
						<div className="d-table">
							<div className="d-table-cell">
								<div className="container">
									<div className="banner-item-content">
										<span className="sub-title">
											Welcome
										</span>
										<h1>{t("home.CPah02")}</h1>
										<p>{t("home.CPap02")}</p>

										<div className="btn-box">
											<Link
												to="/about-us"
												className="default-btn"
											>
												<i className="flaticon-right"></i>
												About Us <span></span>
											</Link>

											<Link
												to="#play-video"
												onClick={(e) => {
													e.preventDefault();
													openModal();
												}}
												className="video-btn popup-youtube"
											>
												<i className="flaticon-google-play"></i>{" "}
												Watch Video
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		</React.Fragment>
	);
};

export default CPa;
